export const initModals = ({
  triggerAttribute = "data-modal",
  modalSelector = ".custom-modal",
  closeSelector = ".custom-modal__close",
} = {}) => {
  document.body.addEventListener("click", (e) => {
    const trigger = e.target.closest(`[${triggerAttribute}]`);
    if (!trigger) return;

    const modalId = trigger.getAttribute(triggerAttribute);
    const modal = document.querySelector(
      `${modalSelector}[${triggerAttribute}="${modalId}"]`
    );
    if (!modal) return;

    const closeBtn = modal.querySelector(closeSelector);

    if (e.target.closest(closeSelector)) return;

    let overlay = document.querySelector(".custom-modal-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.classList.add("custom-modal-overlay");
      document.body.appendChild(overlay);
    }

    const openModal = () => {
      modal.classList.add("open");
      overlay.classList.add("active");
    };

    const closeModal = () => {
      modal.classList.remove("open");
      overlay.remove();

      document.removeEventListener("keydown", escHandler);
    };

    const escHandler = (ev) => {
      if (ev.key === "Escape") closeModal();
    };

    overlay.addEventListener("click", closeModal);

    closeBtn?.addEventListener("click", closeModal, { once: true });

    document.addEventListener("keydown", escHandler);

    openModal();
  });
};
